import { createContext } from 'react'
import { OrganizationType } from '../util/commonTypes'

export const OrgContext = createContext<OrganizationType | undefined>(undefined)
export const OrgDispatchContext = createContext(null)
